import { getItemType } from "../utils/getItemType";
import { stdObject } from "./types/stdObject";

export const emptys = ["", undefined, false, null];

export const emptysDates = [...emptys, "0000-00-00", "0000-00-00 00:00:00"];

export const mainConfig = { url: "" };

export const langsCodes: stdObject = {
  0: "en",
  1: "es",
  2: "hant",
  3: "hans",
};

export const itemStdWidth = 200;
export const chartStdWidth = 350;
export const maxMobileSize = 500;
export const maxCalendarSize = 975;

export const timeLabel = [
  ["years", "year"],
  ["months", "month"],
  ["days", "day"],
];

export const versionsAccess = {
  basic: ["A", "B", "Z"],
  medium: ["A", "B", "C", "F", "Z"],
  full: ["V", "A", "B", "C", "F", "G", "D", "Z"],
};

export const levelExcude: stdObject = {
  basic: { 1: { V: [], A: [], B: [3], Z: [1, 4, 5, 6, 7, 8, 9] } },
  medium: { 1: { V: [], A: [], B: [], C: [], F: [], Z: [] } },
  full: { 1: { V: [], A: [], B: [], C: [], F: [], G: [], D: [], Z: [] } },
};

export const listType: stdObject = {
  std: [],
  D8: { code: "CODRUT", type: "RUT" },
  Z1: { code: "CODGEN", type: "PAI" },
  Z3: { code: "CODSUC", type: "SUC" },
  Z4: { code: "CODADM", type: "ARE" },
  Z7: { code: "CODISU", type: "TAL" },
  Z8: { code: "CODACO", type: "CTPA" },
  Z14: { code: "CODROL", type: "ROL" },
};

export const docsType: stdObject = {
  C2: "SEV",
};

export const timeFormat = {
  order: [2, 1, 0],
  monthName: true,
  fullTime: false,
  delimiter: " / ",
};

export const monthsNames = [
  ["jan", "january"],
  ["feb", "february"],
  ["mar", "march"],
  ["apr", "april"],
  ["may2", "may"],
  ["jun", "june"],
  ["jul", "july"],
  ["ago", "august"],
  ["sep", "september"],
  ["oct", "october"],
  ["nov", "november"],
  ["dic", "december"],
];

export const purchasesCodes = ["PED", "ENT", "CFA", "DEV", "SAL", "TRA"];
export const salesCodes = [
  "COT",
  "ORD",
  "PRE",
  "FAC",
  "REG",
  "RMA",
  "ALC",
  "SEV",
];
export const finalSaleDoc = ["PRE", "FAC", "SEV"];

export const rolPricesforCheckBox = [
  "PRON",
  "ARTN",
  "PROV",
  "CLIV",
  "ARTV",
  "PROP",
  "CLIP",
  "ARTP",
  "POSROL",
  "SELVEN",
  "RENT",
  "COMP",
  "TRAROL",
];

export const recordsShowCodes = [
  ...purchasesCodes,
  ...purchasesCodes.map((e: string) => getItemType(e)),
  ...salesCodes,
  ...salesCodes.map((e: string) => getItemType(e)),
  "DIN",
  "COY",
  "SDD",
];

export const initBatchesDocCodes = ["ENT", "CFA"];

export const extraListCodes = ["PRO", "CLI", "ART"];
export const personsCodes = ["PRO", "CLI"];
export const localListUpdate = ["ART"];

export const noStockDoc = ["PED", "COT"];

export const extrasNewCodes = [
  "SUC",
  "ADM",
  "ISU",
  "ACO",
  "USU",
  "ROL",
  "CAT",
  "MAR",
  "STA",
  "ICA",
  "SHI",
  "D8",
  "V1",
];

export const headerCodes = [
  "CODCAB",
  "GRUCAB",
  "USUCAB",
  "CODTAL",
  "XTAL",
  "YTAL",
  "CODPAG",
  "CODFOR",
  "CODSDA",
  "CODARE",
  "ORDARE",
  "XARE",
  "YARE",
  "CODHOR",
];

export const listedAreas = [
  ...salesCodes,
  ...purchasesCodes,
  ...extraListCodes,
];

export const adultAge = 18;

export const integerType = 6;

export const staffNames = [
  "p.seller",
  "p.helper",
  "p.technician",
  "p.reference",
];

export const docPersonData = [
  "CLI",
  "FEC2",
  "ALM2",
  "RES",
  "TEL",
  "EMA",
  "DOM",
];

export const commBaseOptions = [
  { label: "p.price", value: 0 },
  { label: "p.profitability", value: 1 },
];

// export const docIntData = ["EST3", "FEC2"];
export const serviceExtraCodes = ["C1", "C2", "C3"];
export const docInterventionData = ["INT", "PRE", "PIM", "PAG", "PSE", "POL"];
export const directDocData: stdObject = {
  ALM2: { type: "select" },
  PRE: { type: "select" },
  PIM: { type: "select" },
  PAG: { type: "select", options: "docStatus" },
  ENV: { type: "select", options: "delivery", code: "DEL" },
  TAL: { type: "select", options: "workshops" },
  NOT: { type: "text" },
};

export const excludesTotal = {
  COT: ["ABO", "SAL"],
  SAL: ["IMP", "TOT", "ABO", "SAL"],
};

export const langsList = [
  { CODIDI: 0, NOMIDI: "en" },
  { CODIDI: 1, NOMIDI: "es" },
  { CODIDI: 2, NOMIDI: "hant" },
  { CODIDI: 3, NOMIDI: "hans" },
];

export const alignList: stdObject[] = [
  { ALICAB: 0, ALINOM: "p.left" },
  { ALICAB: 1, ALINOM: "p.center" },
  { ALICAB: 2, ALINOM: "p.right" },
];

export const vAlignList: stdObject[] = [
  { VALCAB: 0, VALNOM: "p.top" },
  { VALCAB: 1, VALNOM: "p.middle" },
  { VALCAB: 2, VALNOM: "p.bottom" },
];

export const fontsOptions = [
  { label: "Verdana" },
  { label: "Helvetica" },
  { label: "sans-serif" },
];

export const itemExtraDataNames = ["IMG", "stock", "sizes", "commissions"];

export const searchMode = [
  "p.equal",
  "p.beginWith",
  "p.finishWith",
  "p.between",
];

export const statusTitles = [
  { code: 0, label: "p.checkbox" },
  { code: 1, label: "p.number" },
  { code: 2, label: "p.text" },
  { code: 3, label: "p.textarea" },
  { code: 4, label: "p.select" },
  { code: 5, label: "p.drawing" },
  { code: 6, label: "p.integer" },
  { code: 7, label: "p.date" },
  { code: 8, label: "p.dictionary" },
  { code: 9, label: "p.separator" },
];

export const titleTexts: stdObject = {
  SUC: { title: "p.askDeleteBranch", nameCode: "NOMSUC" },
  ROL: { title: "p.askDeleteRol", nameCode: "NOMROL" },
  TAL: { title: "p.askDeleteWorkshop", nameCode: "NOMTAL" },
  TAR: { title: "p.askDeletePriceRange", nameCode: "NOMTAR" },
  VTPA: { title: "p.askDeletePaymentType", nameCode: "NOMTPA" },
  CTPA: { title: "p.askDeleteCollectionType", nameCode: "NOMTPA" },
  RUT: { title: "p.askDeleteRoute", nameCode: "NOMRUT" },
  PAG: { title: "p.askDeleteStatus", nameCode: "NOMPAG" },
  FOR: { title: "p.askDeleteForm", nameCode: "NOMFOR" },
  SDA: { title: "p.askDeleteIssue", nameCode: "NOMSDA" },
  ARE: { title: "p.askDeleteDepartment", nameCode: "NOMARE" },
  HOR: { title: "p.askDeleteSchedule", nameCode: "NOMHOR" },
};

export const mainDataHandle: stdObject = {
  MAR: {
    code: "CODMAR",
    name: "NOMMAR",
    newLabel: "p.newBrand",
    callUrl: "callBrand",
    deleteUrl: "deleteBrand",
    askDelete: "p.askDeleteBrand",
  },
  CAJ: {
    code: "CODCAJ",
    name: "NOMCAJ",
    newLabel: "p.newTransaction",
    callUrl: "callMoneyInfo",
    deleteUrl: "deleteMoney",
    askDelete: "p.askDeleteTransaction",
  },
  DIN: {
    code: "CODDIN",
    realCode: "ID",
    callUrl: "callMoneyInfo",
    deleteUrl: "deleteMoney",
    askDelete: "p.askDeletePayment",
  },
};

export const itemsAutoStock = [0, 1, 5];

export const itemsWithBatch = [2, 3, 4];

export const occasionalCustomerField = ["CLI", "NOM", "TEL", "EMA", "DOM"];
export const occasionalResField = ["RES", "NRS"];

export const shortcutCodes = {
  new: "Shift + N",
  print: "Shift + P",
  save: "Shift + S",
  clean: "Shift + C",
};

export const checkFields = [
  { code: "delPay", label: "p.payments" },
  { code: "delComm", label: "p.commissions" },
  { code: "delStock", label: "c.STO" },
];
